import type { Theme } from 'baseui'

export interface PulseLighting {
  shadowPulseTab: string
  shadowPulseSegment: string
  shadowPulseThumb: string
  shadowPulseDirtyTab: string
  shadowPulseFocus: string
  shadowPulseFocusIdle: string
  shadowPulseMenu: string
  shadowPulseMenuSelected: string
  shadowPulseOpen: string
  shadowPulsePopover: string
  shadowPulseModal: string
  shadowPulseFlash: string
  shadowPulseDirtyRingStart: string
  shadowPulseDirtyRingEnd: string
}

// BaseUI types `lighting` without an index signature, unlike `colors`.
export const pulseLighting = (theme: Theme): PulseLighting => theme.lighting as Theme['lighting'] & PulseLighting
